<template>
    <div class="master-template-text-filter">
        <Input v-model="value" search clearable placeholder="Search..." />
    </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

import { deepClone } from "@/utils";
import { FilterType, MasterTemplateLibraryAction } from "@/store/modules/masterTemplateLibrary";

export default defineComponent({
    name: "MasterTemplateTextFilter",

    props: {
        campaignMasterTemplateIds: {
            type: Array as PropType<string[]>,
            default() {
                return [];
            }
        }
    },

    computed: {
        filterValues() {
            return this.$store.state.masterTemplateLibrary.filters.filter(filter => filter.type === FilterType.Text);
        },

        value: {
            get() {
                if (this.filterValues.length) {
                    const filterValuesCopy = deepClone(this.filterValues);

                    return filterValuesCopy.pop()?.values;
                }

                return "";
            },

            set(newValue: string) {
                this.$store.dispatch(MasterTemplateLibraryAction.UpdateTextFilter, {
                    values: newValue
                });
            }
        }
    },

    beforeUnmount() {
        this.value = "";
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

.master-template-text-filter {
    display: flex;
    margin-right: $spacing;
    justify-content: space-between;
    align-items: center;
    width: 200px;
    flex: 0 0 200px;
    margin-right: $spacing;
}
</style>
